import { useWorkflows, workflowSelector } from '@/store/workflows';
import { NodeShell } from '../NodeShell';
import type { NodeProps } from '@xyflow/react';
import { useEffect, useRef } from 'react';
import { api } from '@/lib/api';

export function EditNode({ data }: NodeProps & { data: { workflowId: string } }) {
  const wf = useWorkflows(workflowSelector(data.workflowId));
  const setEditPrompt = useWorkflows((s) => s.setEditPrompt);
  const debounce = useRef<number | null>(null);

  useEffect(() => {
    if (!wf?.streamerHandle) return;
    if (debounce.current) window.clearTimeout(debounce.current);
    debounce.current = window.setTimeout(() => {
      api.setEditPrompt(wf.streamerHandle!, wf.editPrompt).catch(() => {});
    }, 600);
    return () => {
      if (debounce.current) window.clearTimeout(debounce.current);
    };
  }, [wf?.editPrompt, wf?.streamerHandle]);

  if (!wf) return null;

  const topSlot = (
    <textarea
      className="w-[260px] h-[58px] resize-none bg-ink-900 border border-ink-800 rounded-md px-2 py-1.5 text-xs text-ink-200 placeholder:text-ink-600 focus:outline-none focus:border-accent-500"
      placeholder="edit prompt — e.g. 'punch in on reaction, captions, 9:16'"
      value={wf.editPrompt}
      onChange={(e) => setEditPrompt(wf.id, e.target.value)}
    />
  );

  return (
    <NodeShell title="AI Editing" state={wf.states.edit} width={280} topSlot={topSlot}>
      <div className="text-[11px] text-ink-500">fal.ai render — prompt synced</div>
    </NodeShell>
  );
}
